import tldToCountryCode from '@hydra/utils/tldToCountryCode';

const WOOINDEX_URL = 'https://index.woorank.com/en/reviews';

export const getTechnologyLink = tech => `${WOOINDEX_URL}?technology=${tech}`;

export default (countryCode = 'int') => {
  return countryCode === 'int' ? WOOINDEX_URL : `${WOOINDEX_URL}?country=${tldToCountryCode(countryCode)}`;
};
